export class CardIndicadorSituacao {

    constructor(
        public descricaoSituacao?: string,
        public quantidade?: number,
        public percentual?: string,
    ) {
        
    }
}